import { useCallback } from 'react';
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

export const ProposalsButtonGroup = ({ buttons }) => {
  const createOptionsButton = useCallback(() => {
    let group = (buttons || []).map((item) => {
      return (
        <DropdownItem
          key={item.id}
          onClick={() => item.action()}
          color="danger"
        >
          {item.title}
        </DropdownItem>
      );
    });

    return group;
  }, [buttons]);

  return (
    <div className="border-end border-end-dashed">
      <UncontrolledButtonDropdown>
        <DropdownToggle
          caret
          className="btn-sm text-muted d-flex align-items-center justify-content-center"
          style={{ background: 'transparent', border: 'none' }}
        >
          <i
            className="ri-menu-line"
            style={{
              fontSize: '18px',
            }}
          ></i>
        </DropdownToggle>
        <DropdownMenu right className="dropdownmenu-secondary">
          {createOptionsButton()}
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    </div>
  );
};
